import * as React from "react";
import { Container } from "react-bootstrap";
import { withTranslation, WithTranslation } from "react-i18next";
import EldaEndpointList from "../components/EldaEndpointList";

const InstitutePage: React.FC<WithTranslation> = ({ t }) => {
  return (
    <Container fluid={true}>
      <h1>{t("pages.endpoint.title")}</h1>
      <EldaEndpointList />
    </Container>
  );
};

export default withTranslation()(InstitutePage);
